<template>
  <v-carousel
    v-model="currentDot"
    :show-arrows="false"
    :show-arrows-on-hover="false"
    hide-delimiter-background
    hide-delimiters
    delimiter-icon="mdi-circle"
    :continuous="false"
    class="transactionGroup"
  >
    <v-carousel-item v-for="item in items" :key="item.key">
      <TransactionGroupCard
        @click="onTransactionSelected(item.value[0])"
        :account="getBankAccountByAccountId(item.value[0].bankAccountID)"
        :merchant="item.value[0].merchantName"
        :amount="getTransactionGroupAmount(item.value)"
        :date="item.value[0].timestampFormatted"
        :rawDate="item.value[0].timestamp"
        :count="item.value.length"
        :selected="item.value[0].selected"
        :formatter="formatter"
        :transactionId="item.value[0].id"
      />
    </v-carousel-item>
  </v-carousel>

  <PaginationDots v-if="paginationDots"
    :total-items="items.length"
    :current-index="currentDot"
    :maxDots="visibleDots"
  />
</template>

<script>
import TransactionGroupCard from './TransactionGroupCard.vue';
import PaginationDots from './PaginationDots.vue';

export default {
  name: 'BankCardCarousel',
  components: { TransactionGroupCard, PaginationDots },
  emits: ['transactionSelected'],
  props: {
    items: {
      type: Array,
      required: true
    },
    formatter: {
      type: Object,
      required: true
    },
    bankInfo: {
      type: Object,
      required: true
    },
    paginationDots: {
      type: Boolean,
      default: true
    },
    visibleDots: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      currentDot: 0
    };
  },
  computed: {
  },
  watch: {
    currentDot(newIndex) {
      this.emitCurrentIndex(newIndex);
    },
    items: {
      handler(newItems) {
        // If currentDot is beyond the new items length, adjust it
        if (this.currentDot >= newItems.length && newItems.length > 0) {
          this.currentDot = newItems.length - 1;
        }
        // If no items left, reset to 0
        if (newItems.length === 0) {
          this.currentDot = 0;
        }
      },
      immediate: true
    }
  },
  methods: {
    emitCurrentIndex(index) {
      this.$emit('transactionSelected', index);
    },
    getBankAccountByAccountId(id) {
      return this.bankInfo.accounts.find(ba => ba.id === id);
    },
    getTransactionGroupAmount(group) {
      var total = 0;
      group.forEach(t => total += t.amount);
      return total;
    },
    onTransactionSelected(transaction) {
      this.$emit('transactionSelected', this.currentDot, transaction);
    }
  },
};
</script>

<style scoped>
.transactionGroup {
  height: 230px !important;
  margin-left: -30px;
  margin-right: -30px;
  width: 100vw !important;
}
</style>
